/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var SurfaceConnectionType;
(function (SurfaceConnectionType) {
    SurfaceConnectionType["COMMUNICATIONS"] = "communications";
})(SurfaceConnectionType || (SurfaceConnectionType = {}));
